module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "enter registration cover"
  }, [_c('div', {
    staticClass: "enter__outer"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "enter__inner"
  }, [_c('form', {
    staticClass: "enter-form registration__form",
    attrs: {
      "id": "entry_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendCode($event)
      }
    }
  }, [_c('p', {
    staticClass: "enter__text"
  }, [_vm._v("На номер +" + _vm._s(_vm.phone) + " отправлено sms с кодом")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secretCode),
      expression: "secretCode"
    }],
    staticClass: "enter-text-field",
    attrs: {
      "type": "text",
      "placeholder": "Введите 6-ти значный код"
    },
    domProps: {
      "value": (_vm.secretCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.secretCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "enter-form__button",
    attrs: {
      "type": "submit",
      "value": "Продолжить"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "enter-form__link",
    on: {
      "click": _vm.resendNumber
    }
  }, [_vm._v("Код не пришел!")]), _vm._v(" "), _c('p', {
    staticClass: "enter__text"
  }, [_vm._v("Шаг 2 из 4")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "enter__inner registration__enter-inner"
  }, [_c('div', {
    staticClass: "main-logo registration__logo"
  }, [_c('img', {
    staticClass: "main-logo__item",
    attrs: {
      "src": require("../../../assets/img/logo.png"),
      "alt": "logo"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d025850"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App/Register/Two.vue
// module id = 613
// module chunks = 0